module.exports = __webpack_public_path__ + "static/media/om_beard_medium_long__square.fa5399bf.png";